import {
  EMAIL_KIND_CORRECTIONS_APPLIED,
  EMAIL_KIND_MOUNTING_COMPLETE,
  EMAIL_KIND_PRE_ARCHIVE_UPLOAD,
  EMAIL_KIND_PROJECT_REVIEWED,
  EMAIL_KIND_REVIEW_CHECK,
} from '@/api/client';
import { isReadyState } from '@stages/stages';
import { getBaseStatus, getFullStatus } from './projectStatuses';

/** Письма, которые открываются вместо прямой смены этапа: этап меняет сервер при сохранении окна письма */
export type StageEmailKind =
  | typeof EMAIL_KIND_REVIEW_CHECK
  | typeof EMAIL_KIND_PRE_ARCHIVE_UPLOAD
  | typeof EMAIL_KIND_MOUNTING_COMPLETE
  | typeof EMAIL_KIND_CORRECTIONS_APPLIED
  | typeof EMAIL_KIND_PROJECT_REVIEWED;

/** Точные значения state, переход в которые идёт через окно письма (у «Проверки», «Проверки правок» и «Готов» правило по этапу) */
const EXACT_STATE_EMAILS: ReadonlyArray<readonly [state: string, kind: StageEmailKind]> = [
  [getFullStatus('Монтаж', 'Завершён'), EMAIL_KIND_MOUNTING_COMPLETE],
  [getFullStatus('Проверка', 'Завершена'), EMAIL_KIND_PROJECT_REVIEWED],
];

/** Этапы, письмо которых открывается при входе в этап из любого другого этапа */
const STAGE_ENTRY_EMAILS: ReadonlyArray<readonly [stage: string, kind: StageEmailKind]> = [
  ['Проверка', EMAIL_KIND_REVIEW_CHECK],
  ['Проверка правок', EMAIL_KIND_CORRECTIONS_APPLIED],
];

/**
 * Какое окно письма открыть при смене этапа prevState → nextState; null — этап меняется напрямую.
 * Единое правило для таблицы проектов и нового дизайна.
 */
export function stageTransitionEmailKind(
  prevState: string | null | undefined,
  nextState: string
): StageEmailKind | null {
  for (const [stage, kind] of STAGE_ENTRY_EMAILS) {
    if (nextState === stage) return getBaseStatus(prevState) !== stage ? kind : null;
  }
  if (isReadyState(nextState)) return isReadyState(prevState) ? null : EMAIL_KIND_PRE_ARCHIVE_UPLOAD;
  if (nextState === prevState) return null;
  for (const [state, kind] of EXACT_STATE_EMAILS) {
    if (nextState === state) return kind;
  }
  return null;
}
